export const MOCK_CANDIDATE_EVALUATION = {
  id: "mock-id",
  candidateId: "mock-candidate-id",
  interviewId: "mock-interview-id",
  candidateName: "Pending",
  candidateEmail: "Pending",
  position: "Pending",
  createdAt: new Date().toISOString(),
  recommendationStatus: "Pending",
  candidateImage: null,
  recommendationSummary: "Pending",
  confidenceRationale: "Pending",
  confidenceLevel: "Pending",
  feedback: null,
  pretestQA: [
    {
      question: "Pending",
      answer: "Pending",
    },
  ],
  assessmentQA: [
    {
      question: "Pending",
      answer: "Pending",
    },
  ],
  competencyAreas: [
    { area: "Technical Skills", score: 0, comments: "" },
    { area: "Communication", score: 0, comments: "" },
    { area: "Problem Solving", score: 0, comments: "" },
    { area: "Cultural Fit", score: 0, comments: "" },
    { area: "Leadership", score: 0, comments: "" },
  ],
  strengths: ["Pending"],
  areasOfConcern: ["Pending"],
  evaluationData: {
    summary: {
      keyGaps: ["Pending"],
      riskFactors: ["Pending"],
      keyStrengths: ["Pending"],
      overallScore: 0,
      recommendation: "Pending",
      confidenceLevel: "medium",
      developmentAreas: ["Pending"],
      executiveSummary: "Pending",
      hiringManagerNotes: "Pending",
      confidenceRationale: "Pending",
    },
    additionalNotes: {
      interviewerFeedback: "Pending",
      areasNeedingFollowUp: ["Pending"],
      questionsNotAnswered: [],
      comparisonToTypicalCandidate: "Pending",
    },
    developmentAreas: [],
    scoreCalculation: {
      totalWeight: 0,
      weightedSum: 0,
      overallScore: 0,
      rubricScores: [
        {
          rubric: "Technical Competence",
          weight: 0,
          rawScore: 0,
          weightedScore: 0,
        },
      ],
      cognitiveScore: 0,
      weightedAverage: 0,
      communicationScore: 0,
    },
    interviewDetails: [
      {
        gaps: ["Pending"],
        score: 0,
        reason: "Pending",
        rubric: "Pending",
        weight: 0,
        evidence: {
          quote: "Pending",
          reference: "Pending",
          interpretation: "Pending",
        },
        questions: [
          {
            answerText: "Pending",
            questionText: "Pending",
            answerQuality: "Pending",
          },
        ],
        strengths: ["Pending"],
        scoreLabel: "Pending",
        levelAppropriate: false,
        rubricDescription: "Pending",
      },
    ],
    cognitiveAssessment: {
      clarity: {
        score: 0,
        reason: "Pending",
      },
      decisionMaking: {
        score: 0,
        reason: "Pending",
      },
      problemSolving: {
        score: 0,
        reason: "Pending",
      },
      criticalThinking: {
        score: 0,
        reason: "Pending",
      },
      logicalReasoning: {
        score: 0,
        reason: "Pending",
      },
      overallCognitiveScore: 0,
    },
    communicationAssessment: {
      fluency: {
        score: 0,
        reason: "Pending",
      },
      grammar: {
        score: 0,
        reason: "Pending",
      },
      coherence: {
        score: 0,
        reason: "Pending",
      },
      comprehension: {
        score: 0,
        reason: "Pending",
      },
      adjustmentFactors: [],
      vocabularySufficiency: {
        score: 0,
        reason: "Pending",
      },
      overallCommunicationScore: 0,
    },
  },
};

export const MOCK_CONVERSATION_HISTORY = [
  {
    aiQuestion: "Pending",
    userResponse: "Pending",
    questionTimestamp: new Date().toISOString(),
    responseTimestamp: new Date().toISOString(),
  },
];
